
import downloadLocalFile from '../../utils/download-local-file';

const base64prefix = "data:application/pdf;base64,";
const contentType = "application/pdf";

export default function dataURLtoFile(base64Data, filename) {
    // FOR IE browser use alternative option
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        var sliceSize = 1024;
        var byteCharacters = atob(base64Data);
        //var byteCharacters = decodeURIComponent(escape(window.atob(base64Data)))
        var bytesLength = byteCharacters.length;
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        var byteArrays = new Array(slicesCount);

        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            var begin = sliceIndex * sliceSize;
            var end = Math.min(begin + sliceSize, bytesLength);

            var bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        window.navigator.msSaveOrOpenBlob(new Blob(byteArrays, { type: contentType }), filename);
        return;
    }
    
    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    var dataurl = base64prefix + base64Data;
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    var file = new File([u8arr], filename, { type: mime });

    downloadLocalFile(file, filename);
}